import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 14.2136L11.984 14.2026C11.5596 13.9101 11.1379 13.6194 10.7395 13.2916C10.3386 12.9616 9.80183 12.4839 9.26196 11.8934C8.2179 10.7514 7 9.01215 7 7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7C17 9.01233 15.7821 10.7515 14.738 11.8935C14.1981 12.484 13.6614 12.9617 13.2604 13.2917C12.8621 13.6195 12.4403 13.9101 12.0159 14.2026L12 14.2136ZM13.5 7C13.5 6.17157 12.8284 5.5 12 5.5C11.1716 5.5 10.5 6.17157 10.5 7C10.5 7.82843 11.1716 8.5 12 8.5C12.8284 8.5 13.5 7.82843 13.5 7Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.00008 10H3.10503L1.88281 21H22.1173L20.8951 10H17.0001V12H19.105L19.8828 19H4.11734L4.89512 12H7.00008V10Z"}}]};

const MapInformation2Filled = Vue.extend<IconProps>({
  name: 'MapInformation2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'map-information-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MapInformation2Filled;
